// src/data/comedians/chris-rock.js

const base = {
  id: 'chris-rock',
  slug: 'chris-rock',
  name: 'Chris Rock',
  birthYear: 1965,
  image: require('@/assets/images/img_Chris_Rock.jpeg'),
  famousWorks: [
    'Bring the Pain (1996)',
    'Bigger & Blacker (1999)',
    'Never Scared (2004)',
    'Everybody Hates Chris (creator)',
    'Top Five (2014)',
    'Madagascar franchise (voice)',
    'Saturday Night Live (1990-1993)',
  ],
};

export default [
  {
    ...base,
    lang: 'en',
    nationality: 'American',
    shortBio: 'Sharp social commentator and SNL alumnus',
    bio: `Chris Rock is an American comedian, actor, writer, producer, and director known for his sharp observations on American politics, race relations, and popular culture. He is widely regarded as one of the greatest stand-up comedians of all time.\n\nBorn in Andrews, South Carolina and raised in Brooklyn, New York, Rock began performing stand-up at age 18. He caught the attention of Eddie Murphy, who gave him his first film role in "Beverly Hills Cop II". He joined Saturday Night Live in 1990, raising his profile as a comedian.\n\nRock's breakthrough came with his 1996 HBO special "Bring the Pain", which won him two Emmy Awards and established him as one of comedy's premier voices. His comedy tackles controversial subjects with intelligence and fearlessness, particularly issues of race and relationships.\n\nBeyond stand-up, Rock has had success in film, television, and as a voice actor. His influence on contemporary comedy is significant, with many comedians citing him as an inspiration for his willingness to address difficult subjects with both humor and insight.`,
    style: 'Sharp social commentary, observational, relationship humor, political',
    achievements: [
      'Four Emmy Awards',
      'Three Grammy Awards',
      "Ranked #5 on Comedy Central's list of all-time greatest stand-ups",
      'Peabody Award',
      'Writer and director of successful films',
      'Hollywood Walk of Fame star',
    ],
  },
  {
    ...base,
    lang: 'fr',
    nationality: 'Américain',
    shortBio: 'Commentateur social acéré et ancien de SNL',
    bio: `Chris Rock est un comédien, acteur, écrivain, producteur et réalisateur américain connu pour ses observations tranchantes sur la politique américaine, les relations raciales et la culture populaire. Il est largement considéré comme l'un des plus grands comédiens de stand-up de tous les temps.\n\nNé à Andrews, en Caroline du Sud, et élevé à Brooklyn, Rock a commencé le stand-up à 18 ans. Il a attiré l'attention d'Eddie Murphy, qui lui a donné son premier rôle au cinéma dans "Beverly Hills Cop II". Il a rejoint Saturday Night Live en 1990.\n\nLa percée de Rock est venue avec son spécial HBO de 1996 "Bring the Pain", qui lui a valu deux Emmy Awards et l'a établi comme l'une des voix principales de la comédie. Sa comédie aborde des sujets controversés avec intelligence, en particulier les questions de race et de relations.\n\nAu-delà du stand-up, Rock a connu le succès au cinéma, à la télévision et comme comédien de doublage. Son influence sur la comédie contemporaine est significative.`,
    style: 'Commentaire social acéré, observationnel, humour sur les relations, politique',
    achievements: [
      'Quatre Emmy Awards',
      'Trois Grammy Awards',
      "Classé n°5 par Comedy Central parmi les plus grands stand-ups de tous les temps",
      'Peabody Award',
      'Réalisateur et scénariste de films réussis',
      'Étoile sur le Hollywood Walk of Fame',
    ],
  },
  {
    ...base,
    lang: 'es',
    nationality: 'Americano',
    shortBio: 'Agudo comentarista social y ex miembro de SNL',
    bio: `Chris Rock es un comediante, actor, escritor, productor y director estadounidense conocido por sus agudas observaciones sobre la política americana, las relaciones raciales y la cultura popular. Es ampliamente considerado como uno de los más grandes comediantes de stand-up de todos los tiempos.\n\nNacido en Andrews, Carolina del Sur, y criado en Brooklyn, Rock comenzó a hacer stand-up a los 18 años. Captó la atención de Eddie Murphy, quien le dio su primer papel en el cine. Se unió a Saturday Night Live en 1990.\n\nLa gran oportunidad de Rock llegó con su especial de HBO de 1996 "Bring the Pain", que le valió dos Emmy Awards y lo estableció como una de las voces principales de la comedia. Su comedia aborda temas controvertidos con inteligencia, especialmente las cuestiones de raza y relaciones.\n\nMás allá del stand-up, Rock ha tenido éxito en el cine, la televisión y como actor de voz. Su influencia en la comedia contemporánea es significativa.`,
    style: 'Comentario social agudo, observacional, humor sobre relaciones, político',
    achievements: [
      'Cuatro Emmy Awards',
      'Tres Grammy Awards',
      "Clasificado n.º 5 por Comedy Central entre los mejores stand-ups de todos los tiempos",
      'Peabody Award',
      'Escritor y director de películas exitosas',
      'Estrella en el Paseo de la Fama de Hollywood',
    ],
  },
  {
    ...base,
    lang: 'ar',
    nationality: 'أمريكي',
    shortBio: 'المعلّق الاجتماعي الحاد وخريج SNL',
    bio: `كريس روك كوميدي وممثل وكاتب ومنتج ومخرج أمريكي اشتُهر بملاحظاته الحادة حول السياسة الأمريكية والعلاقات العرقية والثقافة الشعبية. يُعدّ على نطاق واسع من أعظم كوميديي الستاند أب على الإطلاق.\n\nوُلد في أندروز بكارولينا الجنوبية ونشأ في بروكلين بنيويورك، وبدأ في الستاند أب في سن الثامنة عشرة. استوقفه إيدي مورفي وأسند إليه دوره الأول في السينما. انضم إلى Saturday Night Live عام 1990.\n\nجاء اختراقه مع عرض HBO الخاص "Bring the Pain" عام 1996 الذي فاز بفضله بجائزتَي Emmy وأثبت نفسه أحد أبرز أصوات الكوميديا. تتناول كوميديا موضوعات مثيرة للجدل بذكاء وجرأة، لا سيما قضايا العرق والعلاقات.\n\nبعيدًا عن الستاند أب، حقق روك نجاحات في السينما والتلفزيون والتمثيل الصوتي. تأثيره على الكوميديا المعاصرة بالغ الأهمية.`,
    style: 'تعليق اجتماعي حاد، ملاحظاتي، فكاهة العلاقات، سياسي',
    achievements: [
      'أربع جوائز Emmy',
      'ثلاث جوائز Grammy',
      'صنّفته Comedy Central الخامس في قائمة أعظم كوميديي الستاند أب على الإطلاق',
      'جائزة Peabody',
      'كاتب ومخرج أفلام ناجحة',
      'نجمة على ممشى المشاهير في هوليوود',
    ],
  },
];
